import React, { useMemo } from 'react';
import {
  Alert, Button, Col, Row,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SelectSensorsSummary from '../SelectSensorsSection/SelectSensorsSummary';
import DefineActionsSummary from '../DefineActionsSection/DefineActionsSummary';
import NameAlertAndMoreSummary from '../NameAlertAndMoreSection/NameAlertAndMoreSummary';
import DefineThresholdsSummary from '../DefineThresholdSection/DefineThresholdsSummary';
import {
  AlertFormSteps,
  selectIsEditingAlertForm,
  selectReviewData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';

function SingleAlertFormReview({
  goToStep, onBack, onCreate, onCancel,
}) {
  const isEdit = useSelector(selectIsEditingAlertForm);
  const { unexpectedError, errorData = [], isSubmitting } = useSelector(selectReviewData);

  const hasUnexpectedError = !!unexpectedError;
  const hasFieldErrors = errorData.length > 0;

  const formattedErrors = useMemo(
    () => errorData.map(({ field, message }) => {
      const readableField = field
        .replace(/^alertNamePairs\[\d+\]\./, '')
        .replace(/([A-Z])/g, ' $1')
        .toLowerCase();

      return `${readableField} ${message}`;
    }),
    [errorData],
  );

  return (
    <div>
      <div className="mb-3">
        <SelectSensorsSummary
          isEdit={isEdit}
          onEdit={() => goToStep(AlertFormSteps.SELECT_SENSORS)}
        />
      </div>
      <div className="mb-3">
        <DefineThresholdsSummary onEdit={() => goToStep(AlertFormSteps.DEFINE_THRESHOLD)} />
      </div>
      <div className="mb-3">
        <DefineActionsSummary onEdit={() => goToStep(AlertFormSteps.DEFINE_ACTIONS)} />
      </div>
      <div className="mb-3">
        <NameAlertAndMoreSummary onEdit={() => goToStep(AlertFormSteps.NAME_ALERT)} />
      </div>

      {hasUnexpectedError && (
        <div className="mt-4">
          <Alert variant="danger" className="mb-3">
            {hasFieldErrors ? (
              <>
                <div className="mb-2">
                  Please fix the following errors:
                </div>
                <ul className="mb-0">
                  {formattedErrors.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </>
            ) : (
              <div className="mb-0">
                An unexpected error has occurred, please try again or contact support.
              </div>
            )}
          </Alert>
        </div>
      )}

      <Row>
        {isEdit ? (
          <Col>
            <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </Button>
          </Col>
        ) : (
          <Col>
            <Button variant="secondary" onClick={onBack} disabled={isSubmitting}>
              <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
              Go back and make changes
            </Button>
          </Col>
        )}
        <Col className="text-right">
          <Button variant="primary" onClick={onCreate} disabled={isSubmitting}>
            {isEdit ? 'Apply Changes' : 'Create Alert'}
          </Button>
        </Col>
      </Row>
    </div>
  );
}

SingleAlertFormReview.propTypes = {
  goToStep: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SingleAlertFormReview;
